export default "__VITE_ASSET__CL37li1C__"